export default __webpack_public_path__ + "static/media/puesc-warning.2379dbb4.svg";